import React from "react";
import ShimmerVersion2 from "../../../../../components/Shimmer/ShimmerVersion2";
import {
  FaqShimmerBlock,
  FaqShimmerItem,
  ShimmerBar,
  ShimmerCard,
  ShimmerCardsRow,
  ShimmerContentBlock,
  ShimmerHeaderRow,
  ShimmerLayout,
  ShimmerLogo,
  ShimmerSection,
  ShimmerTitleBlock,
  WhyBookShimmerGrid,
  WhyBookShimmerItem,
} from "./ListingShimmer.styles";

const CARD_COUNT = 4;
const FAQ_COUNT = 3;

export const ShimmerCardSkeleton = () => <ShimmerCard />;

export const PlanCardsShimmer = () => (
  <ShimmerContentBlock>
    <ShimmerHeaderRow>
      <ShimmerLogo />
      <ShimmerTitleBlock>
        <ShimmerBar $width="249px" $height="36px" />
        <ShimmerBar $width="301px" $height="14px" />
      </ShimmerTitleBlock>
    </ShimmerHeaderRow>
    <ShimmerCardsRow>
      {Array.from({ length: CARD_COUNT }).map((_, i) => (
        <ShimmerCardSkeleton key={i} />
      ))}
    </ShimmerCardsRow>
  </ShimmerContentBlock>
);

const ListingShimmer: React.FC = () => {
  return (
    <ShimmerLayout>
      <ShimmerSection>
        <PlanCardsShimmer />
      </ShimmerSection>

      <ShimmerSection>
        <ShimmerVersion2 width="200px" height="28px" />
        <WhyBookShimmerGrid>
          {Array.from({ length: 6 }).map((_, i) => (
            <WhyBookShimmerItem key={i}>
              <ShimmerVersion2 width="36px" height="36px" />
              <ShimmerTitleBlock>
                <ShimmerVersion2 width="160px" height="16px" />
                <ShimmerVersion2 width="200px" height="12px" />
              </ShimmerTitleBlock>
            </WhyBookShimmerItem>
          ))}
        </WhyBookShimmerGrid>
      </ShimmerSection>

      <ShimmerSection>
        <ShimmerVersion2 width="180px" height="28px" />
        <FaqShimmerBlock>
          {Array.from({ length: FAQ_COUNT }).map((_, i) => (
            <FaqShimmerItem key={i}>
              <ShimmerVersion2 width="80%" height="16px" />
            </FaqShimmerItem>
          ))}
        </FaqShimmerBlock>
      </ShimmerSection>
    </ShimmerLayout>
  );
};

export default ListingShimmer;
